import * as React from 'react'
import Card from '../../atoms/Card'
import * as S from './ExpressCheckoutLoadingSkeleton.styles'

const ExpressCheckoutLoadingSkeleton: React.FC = () => {
  return (
    <Card>
      <S.LoadingTitle data-testid="skeleton loading" />
      <S.LoadingText />
    </Card>
  )
}

export default ExpressCheckoutLoadingSkeleton
